module.exports = __webpack_public_path__ + "assets/img/show_2.60133af5.png";